module.exports = __webpack_public_path__ + "img/award.1b354b43.png";